import { postTrackingData } from "@/api/endpoints/track";
import { EVENT } from "@/tracking_events";
import Doughnut from "@components/Charts/Doughnut";
import ClickHandlerPlugin from "@components/Charts/plugins/ClickHandlerPlugin";

import { BaseWidget } from "../BaseWidget";
import { toPieData } from "./utils";
import { WidgetProps } from "./WidgetProps";

import styles from "./InsightWidgets.module.css";

type TopicsData = {
  results: {
    labels: string[];
    dataset: { label: string; data: number[] }[];
  };
}[];

const TopicsShare: React.FunctionComponent<WidgetProps<TopicsData>> = (
  props
) => {
  const { data } = props;
  const chartData = data?.length && toPieData(data?.[0]?.results.dataset);

  const hasData = data?.some(({ results }) => results?.dataset?.length);

  return (
    <BaseWidget
      containerClassName={styles.pie}
      hasData={hasData}
      {...props}
      title={L.REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOPICS}
      description={L.REPORTS_WIDGET_DEFAULT_TITLE_INSIGHTS_TOPICS_SUBTITLE}
    >
      {chartData && (
        <Doughnut
          data={chartData}
          options={{
            plugins: {
              click: {
                onClick: (appliedFilters) => {
                  postTrackingData(EVENT.WIDGET_CLICK, {
                    widget: props.metric,
                  });
                  props.fetchMentions_v2(appliedFilters);
                },
              },
              tooltip: {
                callbacks: {
                  label: () => {
                    return "";
                  },
                },
              },
            },
          }}
          plugins={[ClickHandlerPlugin]}
        />
      )}
    </BaseWidget>
  );
};

export default TopicsShare;
